import React, { useEffect, useRef, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useDispatch, useSelector } from 'react-redux';
import AskDialog from '../../../components/common/dialog/AskDialog';
import { useNavigate } from 'react-router-dom';
import * as chanceApi from '../../../lib/api/chance';
import _ from 'lodash';
import { setChance } from '../../../modules/chanceModule/chance';
import { Box, Stepper, Step, StepLabel, Grid, Button } from '@mui/material';
import ChanceConfirmContainer from './ChanceConfirmContainer';
import ChanceNeedsAnanlysisContainer from './ChanceNeedsAnanlysisContainer';
import ChanceEstimateContainer from './ChanceEstimateContainer';
import ChanceOrderContainer from './ChanceOrderContainer';
import ChanceStepInfoContainer from '../info/ChanceStepInfoContainer';
import ChanceGuideContainer from '../info/ChanceGuideContainer';
import ChanceFailModal from '../../../components/chancemng/info/ChanceFailModal';

const steps = [
  { value: 0, label: '기회 확인', color: 'info' },
  { value: 1, label: '기회 분석', color: 'error' },
  { value: 2, label: '매출 견적', color: 'success' },
  { value: 3, label: '수주 품의', color: 'secondary' },
];

const ChanceStepperContainer = ({ activeStep, activeTap, handleTabChange }) => {
  const stepperRef = useRef();

  const dispatch = useDispatch();
  let navigate = useNavigate();
  const [isAuth, setIsAuth] = useState(false);
  const { enqueueSnackbar } = useSnackbar();
  const { chance, user } = useSelector(({ chanceModule, auth }) => ({
    chance: chanceModule.chance.chance,
    user: auth.user,
  }));

  useEffect(() => {
    const findIndex = _.findIndex(
      user?.privilegeList,
      (auth) => auth?.authTyp === 'NO_PERPROMANCE' && auth?.authYn === 'Y',
    );
    // console.log(findIndex, 'findIndex');
    if (findIndex !== -1) {
      setIsAuth(true);
    }
  }, [user]);

  const [message, setMessage] = useState(
    '기본사항 등록이 완료되지 못했습니다.',
  );
  const [visible, setVisible] = useState(false);
  const onCancle = () => {
    setVisible(false);
  };
  const onConfirm = () => {
    setVisible(false);
  };

  const [failVisible, setFailVisible] = useState(false);
  const onFailCancle = () => {
    setFailVisible(false);
  };
  const onFailConfirm = (failTxt) => {
    //수주실패
    onFailProject(failTxt);
    setFailVisible(false);
  };

  const onFailProject = async (failTxt) => {
    let dataToSubmit = {
      prjUuid: chance.prjUuid,
      cstStatus: '수주실패',
      failTxt: failTxt,
      useYn: 'N',
    };

    try {
      const res = await chanceApi.editChance(dataToSubmit);
      if (res.data) {
        navigate('/chancemng');
        enqueueSnackbar(`프로젝트 종료 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const [copyVisible, setCopyVisible] = useState(false);
  const onCopyCancle = () => {
    setCopyVisible(false);
  };
  const onCopyConfirm = () => {
    //프로젝트 복사
    onCopyProject();
    setCopyVisible(false);
  };

  const onCopyProject = async () => {
    try {
      const res = await chanceApi.copyChance(chance.prjUuid);
      if (res.data) {
        navigate('/chancemng');
        enqueueSnackbar(`프로젝트 복사 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const [removeVisible, setRemoveVisible] = useState(false);
  const onRemoveCancle = () => {
    setRemoveVisible(false);
  };
  const onRemoveConfirm = () => {
    //프로젝트 삭제
    onRemoveProject();
    setRemoveVisible(false);
  };

  const onRemoveProject = async () => {
    try {
      const res = await chanceApi.removeChance(chance?.prjUuid);
      if (res.data) {
        navigate('/chancemng');
        enqueueSnackbar(`프로젝트 삭제 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const handleNext = () => {
    //현재 단계에서 모든 상세가 입력되었는지 확인
    const valid = checkValidation(chance);
    if (!valid) {
      setVisible(true);
      return;
    } else {
      let dataToSubmit = {
        prjUuid: chance.prjUuid,
      };

      if (Number(chance.cstGrade) === 1) {
        dataToSubmit.cstGrade = 2;
        dataToSubmit.cstStatus = '기회분석';
        updateChanceStatus(dataToSubmit);
      }

      if (Number(chance.cstGrade) === 2) {
        dataToSubmit.cstGrade = 3;
        dataToSubmit.cstStatus = '견적';
        updateChanceStatus(dataToSubmit);
      }

      if (Number(chance.cstGrade) === 3) {
        dataToSubmit.cstGrade = 4;
        dataToSubmit.cstStatus = '수주';
        updateOrderStatus(dataToSubmit);
      }
    }
  };

  const updateOrderStatus = async (dataToSubmit) => {
    try {
      const res = await chanceApi.getEstimateCount(chance.prjUuid);
      if (!res.data.count || res.data.count === 0) {
        setMessage('작성된 견적서가 없습니다. 견적서를 작성하세요');
        setVisible(true);
        return;
      } else {
        updateChanceStatus(dataToSubmit);
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const updateChanceStatus = async (dataToSubmit) => {
    let moveTab = 1;
    if (dataToSubmit.cstGrade === 3) {
      moveTab = 3;
    } else if (dataToSubmit.cstGrade === 4) {
      moveTab = 6;
    }
    try {
      const res = await chanceApi.editChance(dataToSubmit);
      if (res.data) {
        dispatch(setChance(res.data.info));
        navigate(
          `/chancemng/${dataToSubmit.prjUuid}/${dataToSubmit.cstGrade}/${moveTab}`,
        );
        enqueueSnackbar(`[${dataToSubmit.cstStatus}] 상태 변경 성공`, {
          variant: 'success',
        });
      }
    } catch (err) {
      let message =
        typeof err.response !== 'undefined'
          ? err.response.data.message
          : err.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }
  };

  const checkValidation = () => {
    let valid = false;
    if (activeStep === 0) {
      valid = checkValid1();
    } else if (activeStep === 1) {
      valid = checkValid2();

      if (valid) {
        if (
          chance.costYn === null ||
          chance.costYn === undefined ||
          chance.costYn === '' ||
          chance.costYn === 'N'
        ) {
          valid = false;
          setMessage(
            '원가산출이 확정되지 않았습니다. 원가산출관리에서 확정하십시오',
          );
        }
      }
    } else if (activeStep === 2) {
      valid = checkValid3();

      if (valid) {
        if (
          chance.costYn === null ||
          chance.costYn === undefined ||
          chance.costYn === '' ||
          chance.costYn === 'N'
        ) {
          valid = false;
          setMessage(
            '원가산출이 확정되지 않았습니다. 원가산출관리에서 확정하십시오',
          );
        }
      }
    }

    return valid;
  };

  const checkValid1 = () => {
    let valid = true;
    if (
      chance.cstNm === null ||
      chance.cstNm === undefined ||
      chance.cstNm === ''
    ) {
      setMessage('사업명이 등록되지 않았습니다.');
      valid = false;
    }
    // if (
    //   chance.partnerInc === null ||
    //   chance.partnerInc === undefined ||
    //   chance.partnerInc === ''
    // ) {
    //   setMessage('고객명이 등록되지 않았습니다.');
    //   valid = false;
    // }
    // if (
    //   chance.chargeNm === null ||
    //   chance.chargeNm === undefined ||
    //   chance.chargeNm === ''
    // ) {
    //   setMessage('고객 담당자명이 등록되지 않았습니다.');
    //   valid = false;
    // }
    // if (
    //   chance.chanceTyp === null ||
    //   chance.chanceTyp === undefined ||
    //   chance.chanceTyp === ''
    // ) {
    //   setMessage('기회구분이 등록되지 않았습니다.');
    //   valid = false;
    // }
    if (
      chance.prjImpt === null ||
      chance.prjImpt === undefined ||
      chance.prjImpt === ''
    ) {
      setMessage('프로젝트 중요도가 등록되지 않았습니다.');
      valid = false;
    }
    if (
      chance.bugetYn === null ||
      chance.bugetYn === undefined ||
      chance.bugetYn === ''
    ) {
      setMessage('예산여부가 등록되지 않았습니다.');
      valid = false;
    }
    if (
      chance.partnerTyp === null ||
      chance.partnerTyp === undefined ||
      chance.partnerTyp === ''
    ) {
      setMessage('거래처유형이 등록되지 않았습니다.');
      valid = false;
    }
    return valid;
  };
  const checkValid2 = () => {
    let valid = checkValid1();

    // if (
    //   chance.incTyp === null ||
    //   chance.incTyp === undefined ||
    //   chance.incTyp === ''
    // ) {
    //   setMessage('산업체 구분이 등록되지 않았습니다.');
    //   valid = false;
    // }

    // if (
    //   chance.solutionTyp === null ||
    //   chance.solutionTyp === undefined ||
    //   chance.solutionTyp === ''
    // ) {
    //   setMessage('아이템 구분이 등록되지 않았습니다.');
    //   valid = false;
    // }

    if (
      chance.productYn === null ||
      chance.productYn === undefined ||
      chance.productYn === ''
    ) {
      setMessage('제품 여부가 등록되지 않았습니다.');
      valid = false;
    }

    if (
      chance.vendorCmp === null ||
      chance.vendorCmp === undefined ||
      chance.vendorCmp === ''
    ) {
      setMessage('매출처가 등록되지 않았습니다.');
      valid = false;
    }

    // if (
    //   chance.vendorEmp === null ||
    //   chance.vendorEmp === undefined ||
    //   chance.vendorEmp === ''
    // ) {
    //   setMessage('매출처 담당자가 등록되지 않았습니다.');
    //   valid = false;
    // }

    if (
      chance.expBenefitRate === null ||
      chance.expBenefitRate === undefined ||
      chance.expBenefitRate === ''
    ) {
      setMessage('원가산출이 완료되지 않았습니다');
      valid = false;
    }

    if (
      chance.expSales === null ||
      chance.expSales === undefined ||
      chance.expSales === ''
    ) {
      setMessage('원가산출이 완료되지 않았습니다');
      valid = false;
    }

    if (
      chance.expBuy === null ||
      chance.expBuy === undefined ||
      chance.expBuy === ''
    ) {
      setMessage('원가산출이 완료되지 않았습니다');
      valid = false;
    }

    //isAuth가 true이면 skip => "NO_PERPROMANCE" 권한자는 true
    if (!isAuth) {
      // isAuth가 true일떄는 계산안함.
      // if (chance?.expBenefitRate === '0.00') {
      //   setMessage('예상이익률이 0.00입니다. 재확인하세요.');
      //   valid = false;
      // }

    }

    if (
      chance.expDay === null ||
      chance.expDay === undefined ||
      chance.expDay === ''
    ) {
      setMessage('매출 예상일이 등록되지 않았습니다');
      valid = false;
    }

    if (chance.costYn !== 'Y') {
      setMessage('원가산출이 확정되지 않았습니다.');
      valid = false;
    }

    return valid;
  };
  const checkValid3 = () => {
    let valid = checkValid1() && checkValid2();
    // if (valid) {
    //   if (
    //     chance.mtnFreeSt === null ||
    //     chance.mtnFreeSt === undefined ||
    //     chance.mtnFreeSt === ''
    //   ) {
    //     setMessage('무상 유지 보수 시작일이 등록되지 않았습니다');
    //     valid = false;
    //   }

    //   if (
    //     chance.mtnFreeEd === null ||
    //     chance.mtnFreeEd === undefined ||
    //     chance.mtnFreeEd === ''
    //   ) {
    //     setMessage('무상 유지 보수 종료일이 등록되지 않았습니다');
    //     valid = false;
    //   }
    // }
    return valid;
  };

  return (
    <Box sx={{ width: '100%' }}>
      {/*
      <Grid container spacing={2} sx={{ height: '300px', my: 1 }}>
        <Grid item xs={4}>
          <ChanceStepInfoContainer />
        </Grid>
        <Grid item xs={8}>
          <ChanceGuideContainer />
        </Grid>
      </Grid>
      */}
      <div ref={stepperRef}></div>
      <Box sx={{ 
        mt: -1.8,
        border: '1px solid', 
        borderColor: 'divider', 
        borderRadius: 1, 
        bgcolor: 'background.paper',
        height: 80,
        px: 1, 
        py: 1.5, // 글자가 커진 만큼 상하 여백을 살짝 조정해 균형을 맞춤
        boxShadow: '0 1px 3px rgba(0,0,0,0.05)' 
      }}>
        <Stepper 
          activeStep={activeStep} 
          alternativeLabel 
          sx={{
            backgroundColor: 'transparent',
            '& .MuiStepConnector-line': { borderColor: '#e0e0e0', borderTopWidth: 2 },
            '& .MuiStepConnector-root.Mui-active .MuiStepConnector-line': { borderColor: 'primary.main' },
            '& .MuiStepConnector-root.Mui-completed .MuiStepConnector-line': { borderColor: 'primary.main' }
          }}
        >
          {steps.map((step, index) => {
            const stepProps = {};
            if (activeStep === steps.length - 1) stepProps.completed = true;

            return (
              <Step key={step.label} {...stepProps}>
                <StepLabel
                  StepIconProps={{
                    sx: {
                      fontSize: '1.5rem', // 글자 크기에 맞춰 아이콘도 시원하게 키움
                      '&.Mui-active': { color: 'primary.main' },
                      '&.Mui-completed': { color: 'primary.main' },
                    }
                  }}
                  sx={{
                    '& .MuiStepLabel-label': {
                      mt: 0.8, 
                      fontSize: '0.85rem', // 글자 크기 확대 (가독성 확보)
                      fontWeight: activeStep === index ? 'bold' : '500',
                      color: activeStep === index ? 'primary.main' : 'text.secondary',
                      whiteSpace: 'nowrap'
                    }
                  }}
                >
                  {step.label}
                </StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Box>


      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          py: 2,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'flex-start',
            alignItems: 'center',
          }}
        >
          <Box>
            <Button
              variant="contained"
              color="error"
              onClick={() => setRemoveVisible(true)}
            >
              삭제
            </Button>
          </Box>
          <Box sx={{ mx: 2 }}>
            <Button
              variant="contained"
              color="success"
              onClick={() => setCopyVisible(true)}
            >
              복사
            </Button>
          </Box>
        </Box>

        <Box sx={{ flex: '1 1 auto' }} />
        <Box sx={{ mr: 2 }}>
          <Button
            variant="contained"
            color="default"
            onClick={() => setFailVisible(true)}
          >
            수주 실패
          </Button>
        </Box>
        {activeStep < steps.length - 1 && (
          <Button
            variant="contained"
            color={steps[activeStep + 1].color}
            onClick={handleNext}
          >
            {steps[activeStep + 1].label}
          </Button>
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'flex-start',
        }}
      >
        {activeStep === 0 && (
          <ChanceConfirmContainer
            activeTap={activeTap}
            handleTabChange={handleTabChange}
            stepperRef={stepperRef}
          />
        )}
        {activeStep === 1 && (
          <ChanceNeedsAnanlysisContainer
            activeTap={activeTap}
            handleTabChange={handleTabChange}
            stepperRef={stepperRef}
          />
        )}
        {activeStep === 2 && (
          <ChanceEstimateContainer
            activeTap={activeTap}
            handleTabChange={handleTabChange}
            stepperRef={stepperRef}
          />
        )}
        {activeStep === 3 && (
          <ChanceOrderContainer
            activeTap={activeTap}
            handleTabChange={handleTabChange}
            stepperRef={stepperRef}
          />
        )}
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'flex-start',
          alignItems: 'center',
          py: 2,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Box>
          <Button
            variant="contained"
            color="error"
            onClick={() => setRemoveVisible(true)}
          >
            삭제
          </Button>
        </Box>

        <Box sx={{ flex: '1 1 auto' }} />
        <Box sx={{ mr: 2 }}>
          <Button
            variant="contained"
            color="default"
            onClick={() => setFailVisible(true)}
          >
            수주 실패
          </Button>
        </Box>
        {activeStep < steps.length - 1 && (
          <Button
            variant="contained"
            color={steps[activeStep + 1].color}
            onClick={handleNext}
          >
            {steps[activeStep + 1].label}
          </Button>
        )}
      </Box>

      <AskDialog
        visible={visible}
        title="다음단계 이동"
        description={message}
        onConfirm={onConfirm}
        onCancle={onCancle}
      />
      <ChanceFailModal
        visible={failVisible}
        title="경고 : 프로젝트 수주 실패"
        description="더이상 사업 진행이 되지 않습니다."
        onConfirm={onFailConfirm}
        onCancle={onFailCancle}
      />
      <AskDialog
        visible={copyVisible}
        title="프로젝트 복사"
        description="해당 프로젝트를 복사하시겠습니까?"
        onConfirm={onCopyConfirm}
        onCancle={onCopyCancle}
      />
      <AskDialog
        visible={removeVisible}
        title="프로젝트 삭제"
        description="해당 프로젝트를 삭제하시겠습니까?(복구 불가)"
        onConfirm={onRemoveConfirm}
        onCancle={onRemoveCancle}
      />
    </Box>
  );
};

export default ChanceStepperContainer;
